export const alertsInitialState = {
  alert: null,
}

export const ALERTS_ACTIONS = {
  CREATE_ALERT: 'CREATE_ALERT',
  REMOVE_ALERT: 'REMOVE_ALERT',
}

export const alertsActions = {
  [ALERTS_ACTIONS.CREATE_ALERT]: (_, { alert }) => {
    return { alert }
  },

  [ALERTS_ACTIONS.REMOVE_ALERT]: () => {
    return { alert: null }
  },
}
